import { useEffect, useState } from 'react'
import { subscribeToUsers } from '@/features/users/users-api'
import type { UserProfile } from '@/lib/types'

type UsersState = {
  users: UserProfile[]
  isLoading: boolean
  error: string | null
}

/** Subscribes to `users` for as long as the page is mounted. */
export function useUsers(): UsersState {
  const [state, setState] = useState<UsersState>({ users: [], isLoading: true, error: null })

  useEffect(() => {
    return subscribeToUsers(
      (users) => setState({ users, isLoading: false, error: null }),
      (error) =>
        setState({
          users: [],
          isLoading: false,
          error:
            error.message.includes('permission')
              ? 'Firestore отклонил чтение коллекции users. Проверьте, что правила опубликованы и у вас роль admin.'
              : error.message,
        }),
    )
  }, [])

  return state
}
